jQuery(".logo-slider").slick({
   slidesToShow: 5,
   infinite:false,
   slidesToScroll: 1,
  arrows: false,
   autoplay: true,
   autoplaySpeed: 2000,
  responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        }
      },
          {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
        }
      },
    
    ]
  });

jQuery(".product-slider").slick({
   slidesToShow: 3,
   infinite:false,
   slidesToScroll: 1,
  arrows: false,
   autoplay: false,
   autoplaySpeed: 2000,
  responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2.3,
        }
      },
          {
        breakpoint: 575,
        settings: {
          slidesToShow: 1.2,
        }
      },
    
    ]
  });

jQuery(".product-slider-new").slick({
   slidesToShow: 3,
   infinite:false,
   slidesToScroll: 1,
  arrows: false,
   autoplay: false,
   autoplaySpeed: 2000,
  responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2.3,
        }
      },
          {
        breakpoint: 575,
        settings: {
          slidesToShow: 1.2,
        }
      },
    
    ]
  });

// Tiktok video slider
jQuery(".tiktok-video-slider").slick({
   slidesToShow: 5.3,
   infinite:false,
   slidesToScroll: 1,
  arrows: false,
   autoplay: false,
  responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4.3,
        }
      },
          {
        breakpoint: 575,
        settings: {
          slidesToShow: 3,
        }
      },
    
    ]
  });


// ========= video =============
// jQuery(document).ready(function () {
//     jQuery(".play-btn-info").click(function () {
//         console.log("Play button clicked");

//         let videoWrapper = jQuery(this).closest(".video-info");
//         let currentVideo = videoWrapper.find("video")[0]; 
//         let playIcon = videoWrapper.find(".fa-play");
//         let pauseIcon = videoWrapper.find(".fa-pause");

//         if (currentVideo.paused) {
//             // Pause all other videos before playing the selected one
//             jQuery(".tv_video").each(function () {
//                 if (this !== currentVideo) {
//                     this.pause();
//                     this.currentTime = 0; // Reset video to start
//                     jQuery(this).closest(".video-info").find(".poster-img, .video-open-icon").show();
//                     jQuery(this).closest(".video-info").find(".fa-play").show();
//                     jQuery(this).closest(".video-info").find(".fa-pause").hide();
//                 }
//             });

//             // Hide the poster and play button, then play the video
//             videoWrapper.find(".poster-img, .video-open-icon").hide();
//             currentVideo.play();
//         } else {
//             currentVideo.pause();
//         }
//     });

//     // Ensure UI updates when video plays
//     jQuery(".tv_video").on("play", function () {
//         let videoWrapper = jQuery(this).closest(".video-info");
//         videoWrapper.find(".poster-img, .video-open-icon").hide();
//         videoWrapper.find(".fa-play").hide();
//         videoWrapper.find(".fa-pause").show();
//     });

//     // Ensure UI updates when video pauses
//     jQuery(".tv_video").on("pause", function () {
//         let videoWrapper = jQuery(this).closest(".video-info");
//         videoWrapper.find(".poster-img, .video-open-icon").show();
//         videoWrapper.find(".fa-play").show();
//         videoWrapper.find(".fa-pause").hide();
//     });

//     // Reset UI when video ends
//     jQuery(".tv_video").on("ended", function () {
//         let videoWrapper = jQuery(this).closest(".video-info");
//         videoWrapper.find(".poster-img, .video-open-icon").show();
//         videoWrapper.find(".fa-play").show();
//         videoWrapper.find(".fa-pause").hide();
//     });
// });

jQuery(document).ready(function ($) {
  $(".play-btn-info").on("click", function () {
    var videoContainer = $(this).closest(".video-info");
    var video = videoContainer.find("video")[0];
    var playBtnContainer = videoContainer.find(".video-open-icon"); // Hide the entire play button container
    var playBtn = videoContainer.find(".play-btn");
    var playIcon = playBtn.find(".fa-play");
    var pauseIcon = playBtn.find(".fa-pause");
    var poster = videoContainer.find(".poster-img");

    // Pause all other videos
    $("video").each(function () {
      if (this !== video) {
        this.pause();
        var otherContainer = $(this).closest(".video-info");
        otherContainer.find(".video-open-icon").show(); // Show play button again
        otherContainer.find(".fa-play").show();
        otherContainer.find(".fa-pause").hide();
        otherContainer.find(".poster-img").show();
      }
    });

    if (video.paused) {
      video.play();
      playBtnContainer.show(); // Ensure button is visible before modifying icons
      playIcon.hide();
      pauseIcon.show();
      poster.hide();
    } else {
      video.pause();
      playBtnContainer.show();
      playIcon.show();
      pauseIcon.hide();
    }
  });

  // Ensure play button resets when the video ends
  $("video").on("ended", function () {
    var videoContainer = $(this).closest(".video-info");
    var playBtnContainer = videoContainer.find(".video-open-icon");
    playBtnContainer.show();
    playBtnContainer.find(".fa-play").show();
    playBtnContainer.find(".fa-pause").hide();
    videoContainer.find(".poster-img").show();
  });

  // Hide entire play button container when mouse leaves a playing video
  $(".video-info").hover(
    function () {
      var video = $(this).find("video")[0];
      var playBtnContainer = $(this).find(".video-open-icon");
      if (!video.paused) {
        playBtnContainer.show();
        playBtnContainer.find(".fa-play").hide();
        playBtnContainer.find(".fa-pause").show();
      }
    },
    function () {
      var video = $(this).find("video")[0];
      var playBtnContainer = $(this).find(".video-open-icon");
      if (!video.paused) {
        playBtnContainer.hide(); // Hide entire play button container when mouse leaves
      } else {
        playBtnContainer.show(); // Show when the video is paused
        playBtnContainer.find(".fa-play").show();
        playBtnContainer.find(".fa-pause").hide();
      }
    }
  );
});














//
jQuery(document).ready(function () {
    jQuery(".faq-question").click(function () {
        let answer = jQuery(this).next(".faq-answer");

        if (answer.is(":visible")) {
            // Hide the answer if it's already open
            answer.slideUp();
            jQuery(this).find("i").removeClass("fa-minus").addClass("fa-plus");
        } else {
            // Hide other answers before opening this one
            jQuery(".faq-answer").slideUp();
            jQuery(".faq-question i").removeClass("fa-minus").addClass("fa-plus");

            // Show the clicked answer
            answer.slideDown();
            jQuery(this).find("i").removeClass("fa-plus").addClass("fa-minus");
        }
    });
});

jQuery(document).ready(function ($) {
    $("#addToCart").on("click", function (event) {
      event.preventDefault(); // Prevent default behavior (if it's a link or button)

      $("html, body").animate(
        { scrollTop: 0 }, 
        800,  // 800ms duration (adjust for smoothness)
        "swing" // Easing effect for a smoother scroll
      );
    });
  });



document.querySelector('.show_swatch').addEventListener('click', function() {
  // Remove 'hidden' class from all '.products_list li' elements
  document.querySelectorAll('.products_list li').forEach(function(item) {
    item.classList.remove('hidden');
  });

  // Remove the clicked element itself
  this.remove();
});






